export default class Content
{
	static _content;
	static setContent(content)
	{
		this._content = content;
	}

	static getPage(id)
	{
		if(!(this._content || this._content.pages)) return;
		return this._content.pages[id];
	}
}